import app from './app';
import directCustomerQuoteActions from './direct-customer-quote'
import { CATALOG_SERVICE_URL } from '../../libs/constants';

//GET
const getContactSupportDetails = () => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.get(CATALOG_SERVICE_URL + 'contactSupport')
        .then(response => {
            dispatch({
                type: "SET_CONTACT_SUPPORT_DATA",
                payload: response
            });
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};


//GET
const getCategoriesData = requestData => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getCategoriesData"
        }
    };

    await api.get(CATALOG_SERVICE_URL + 'categories', { params: requestData, ...headerConfig })
        .then(response => {
            dispatch({
                type: "SET_CATEGORIES_DATA",
                payload: response
            });
            dispatch(app.setLoading(false));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};


//POST
const getShippingMaterials = (requestData, appMessages, successCallback) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "getShippingMaterials"
        }
    };
    await api.post(CATALOG_SERVICE_URL + 'shippingMaterial/list', requestData, headerConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            if (response.data.hasOwnProperty("shippingMaterialList") && response.data.shippingMaterialList.length) {
                dispatch({
                    type: "SET_MATERIALS_DATA",
                    payload: response
                });

                //const totalCategoriesWeight = response.data.shippingMaterialList.length === 1 && response.data.shippingMaterialList[0].hasOwnProperty("weight") ? response.data.shippingMaterialList[0].weight : 0;

                /*if (totalCategoriesWeight) {
                    dispatch({
                        type: "SET_TOTAL_CATEGORIES_WEIGHT",
                        payload: {
                            weight: totalCategoriesWeight
                        }
                    });
                }
                else {*/
                dispatch({
                    type: "SET_NEW_ORDER_MATERIALS_DATA",
                    payload: {
                        list: response.data.shippingMaterialList,
                        defaultQuantities: response.data.suggestedMaterials || []
                    }
                });
                //}     

                successCallback && successCallback();
            }
            else if (response.data.hasOwnProperty("packagingDetails")) {
                if (response.data.packagingDetails.weight) {
                    dispatch({
                        type: "SET_TOTAL_CATEGORIES_WEIGHT",
                        payload: {
                            weight: response.data.packagingDetails.weight
                        }
                    });

                    successCallback && successCallback();
                }
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
            }
        })
        .catch(error => {
            console.log(error)
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getCountryMappingDetails = (userId, dealType) => async (dispatch, getState, api) => {
    try {
        const deal = dealType || "NA";
        const headerConfig = { headers: { "DRS-Fetch-Type": "getCountryMappingDetails" } };
        const response = await api.post(CATALOG_SERVICE_URL + 'country/mappingDetails/' + userId + `/${deal}`, {}, headerConfig);
        const countryList = response.data.countryMappingDetails.map(country => {
            return country.countryCode;
        })
        dispatch(directCustomerQuoteActions.getRevitalizeVendors({
            countryList: [...countryList]
        }, userId))
        dispatch({ type: "SET_COUNTRY_MAPPING_DETAILS", data: response.data });
    } catch (error) {
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const resetCategoriesData = () => {
    return {
        type: 'RESET_CATEGORIES_DATA',
    }
}

const resetShippingMaterial = () => {
    return {
        type: 'RESET_SHIPPING_MATERIAL',
    }
}

const setMaterialsListRefreshed = () => {
    return {
        type: 'SET_MATERIALS_LIST_REFRESHED',
    }
}

const setPreAuthenticationCatalogData = data => {
    return {
        type: 'SET_PRE_AUTHENTICATION_CATALOG_DATA',
        data: data
    }
}

const resetCatalog = () => {
    return {
        type: 'RESET_CATALOG'
    }
}

const catalogActions = {
    getCategoriesData: getCategoriesData,
    getShippingMaterials: getShippingMaterials,
    setPreAuthenticationCatalogData: setPreAuthenticationCatalogData,
    resetCategoriesData: resetCategoriesData,
    resetShippingMaterial: resetShippingMaterial,
    setMaterialsListRefreshed: setMaterialsListRefreshed,
    resetCatalog: resetCatalog,
    getContactSupportDetails: getContactSupportDetails,
    getCountryMappingDetails
}

export default catalogActions;
